import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { HERO, HeroContext } from '../../../contexts/HeroContext'

import DropdownMenu from '../../dropdown/DropdownMenu'
import PackageSearchForm from './PackageSearchForm'
import useSetDestinationListBarPos from '../../hooks/useSetDestinationListBarPos'
import useSetBackgroundImage from '../../hooks/useSetBackgroundImage'

const TabsPackageDeal = ({
  minNights,
  setMinNights,
  lowestNightsList,
  lowestStay,
  webPSupport,
}) => {
  const { state, dispatch } = useContext(HeroContext)
  const _setActiveDestinationTitle = (title) =>
    dispatch({ type: HERO.ACTIVE_DESTINATION.TITLE, payload: title })
  const _setActiveDesination = (active) =>
    dispatch({ type: HERO.ACTIVE_DESTINATION.SET, payload: active })
  const _setActiveDestinationHeading = (heading) =>
    dispatch({ type: HERO.ACTIVE_DESTINATION.HEADING, payload: heading })
  const _setActiveDestinationNav = (nav) =>
    dispatch({ type: HERO.ACTIVE_DESTINATION.NAV, payload: nav })
  const _setDropdown = (dropdown) =>
    dispatch({ type: HERO.DROPDOWN.SET, payload: dropdown })
  const _setPlaying = (playing) =>
    dispatch({ type: HERO.PLAYING.SET, payload: playing })
  const _setNights = (nights) =>
    dispatch({ type: HERO.NIGHTS.SET, payload: nights })

  const { setListBarSelection } = useSetDestinationListBarPos()
  const { setBackgroundImage } = useSetBackgroundImage()


  const setDropdownContent = (value, featured) => {
    if (value) {
      if(featured) {
        _setActiveDestinationHeading(
          getDestinationData(value, 'verb')
        )
      } else {
        _setActiveDestinationHeading("take a trip to")
      }
    }
  }

  const getDestinationData = (destination, property) => {
    switch (property) {
      case 'verb':
        return state.destinations[destination].verb
      case 'image':
        if (webPSupport) {
          return state.destinations[destination].webp_image
        }
        else {
          return state.destinations[destination].image
        }
      default:
        break
    }
  }

  const getDropdownState = () => state.dropdown.destination.open

  const getActiveDropdown = () => state.dropdown.destination.open ? 'destination' : null

  const getActiveFeaturedDestinations = () => {
    if (state.dropdown.destination.open) return state.featuredDestinations
  }

  const getDestinationsDropdownList = () => state.destinationsDropdownList

  const getActiveHoveredState = () => {
    const active = getActiveDropdown()
    return active ? state.dropdown[active].hovered : null
  }

  const _closeOpenDropdown = (menu) => {
    const dropdownTmp = {...state.dropdown}
    dropdownTmp[menu].open = false
    _setDropdown(dropdownTmp)
  }

  const selectDropdownOption = (menu, option, animated) => {
    const dropdownTmp = {...state.dropdown}
    dropdownTmp[menu].open = false

    if (dropdownTmp[menu].selected !== option.value) {
      dropdownTmp[menu].selected = option.value
      dropdownTmp[menu].hovered  = null

      if (menu === 'destination') {
        setActiveDestination(option)

        if(lowestNightsList) {
          let n = lowestNightsList[option.value] ? lowestNightsList[option.value] : lowestStay
          _setNights(n)
          setMinNights(n)
        }

        if (!animated) {
          let $heroBg = document.querySelector('.hero-bg')
          $heroBg.style.transform = 'scale(1)'
          $heroBg.style.animation = 'none'
        }

        if (state.playing && !animated) {
          clearInterval(window._destinationInterval_)
          _setPlaying(false)
        }
      }
    }
    _setDropdown(dropdownTmp)
  }

  const setDropdownOptionHoverState = (menu, option) => {
    const dropdownTmp = {...state.dropdown}
    dropdownTmp[menu].hovered = option
    _setDropdown(dropdownTmp)
  }

  const setActiveDestination = (option) => {
    let isFeatured = state.featuredDestinations.some(t => t == option.value)
    _setActiveDestinationTitle(option.label)
    _setActiveDesination(option.value)
    _setActiveDestinationNav(option.value)
    setDropdownContent(option.value, isFeatured)
    // if featured destination
    if(isFeatured) {
      setListBarSelection(option.value)
      setBackgroundImage({url: getDestinationData(option.value, 'image'), playing: state.playing})
    }
  }

  return (
    <>
      <PackageSearchForm
        minNights = {minNights}
        />
      {
        getDropdownState() &&
        <DropdownMenu
          menu                          = {getActiveDropdown()}
          getActiveHoveredState         = {getActiveHoveredState}
          getAllDestinations            = {getDestinationsDropdownList}
          setDropdownOptionHoverState   = {setDropdownOptionHoverState}
          selectDropdownOption          = {selectDropdownOption}
          closeOpenDropdown             = {_closeOpenDropdown}
        />
      }
    </>
  )
}

TabsPackageDeal.propTypes = {
  minNights: PropTypes.number.isRequired,
  setMinNights: PropTypes.func.isRequired,
  lowestNightsList: PropTypes.object.isRequired,
  lowestStay: PropTypes.number.isRequired,
  webPSupport: PropTypes.bool.isRequired,
}

export default TabsPackageDeal
